import { DynamicFormConstants } from "../types/DynamicFormConstants";
let initialState = {
  all: [],
  dynamicFormDetails: {},
  isDynamicFormUpdated: false,
};
export function dynamicform(state = initialState, action) {
  switch (action.type) {
    case DynamicFormConstants.DYNAMIC_FORM_REQUEST: {
      state.isDynamicFormUpdated = false;
      return state;
    }
    case DynamicFormConstants.DYNAMIC_FORM_SUCCESS: {
      state.isDynamicFormUpdated = true;
      return state;
    }case DynamicFormConstants.GET_ALL_DYNAMIC_FORM_REQUEST: {
      state.isDynamicFormUpdated = false;
      state.all = [];
      return state;
    }case DynamicFormConstants.GET_ACTIVE_DYNAMIC_FORM_REQUEST: {
      state.isDynamicFormUpdated = false;
      state.all = [];
      return state;
    }case DynamicFormConstants.GET_ALL_DYNAMIC_FORM_SUCCESS: {
      state.all = action.data;
      return state;
    }case DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_REQUEST: {
      state.isDynamicFormUpdated = false;
      state.dynamicFormDetails = {};
      return state;
    }case DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_SUCCESS: {
      state.isDynamicFormUpdated = false;
      state.dynamicFormDetails = action.data;
      return state;
    }case DynamicFormConstants.CLEAR_ALL_DYNAMIC_FORM: {
      state.all = [];
      state.dynamicFormDetails = {};
      state.isDynamicFormUpdated = false;
      return state;
    }
    
    default:
      return state;
  }
}
